module.exports = __webpack_public_path__ + "media/topada-freelance-profile.843427ca.mp4";